export default __webpack_public_path__ + "static/media/android.4ee891ad.svg";